import useSearchParam from "hooks/useSearchParam";

export const FARM_ID_QUERY_STRING_KEY = "farmId";

const useSelectedFarmId = () => useSearchParam(FARM_ID_QUERY_STRING_KEY);

export default useSelectedFarmId;
